// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d7aeaebc","498":"b24a1338","703":"d4c1f141","787":"1cd31a9e"}[chunkId] + ".chunk.js";
};